import { SafeHtml } from '@angular/platform-browser';
import { KeyedCollection } from '../classes';
import { RoleEnum } from '../enums';
import { IContact, IVote } from '../Interfaces';
export namespace CRMApplication {
    export class CRMApplicationModel {
        Attributes: KeyedCollection<IAttribute>;
        Id: string;
        LogicalName: string;
        Members: Member[];
        StartDate: Date;
        Number: number;
        Title: string;
        Acep_Contact: IContact;
    }

    export interface IAttribute {
        Id: string;
        LogicalName: string;
        Value: any;
    }


    export interface IMember {
        Attributes: KeyedCollection<any>;
        LogicalName: string;
        Acep_Contact: IContact;
        Email: string;
        Name: string;
        Vote: IVote;
    }

    export class Member implements IMember {
        Attributes: KeyedCollection<any>;
        LogicalName: string;
        Acep_Contact: IContact;
        Email: string;
        Name: string;
        Vote: IVote;
        get Position(): string {
            let x = RoleEnum[this.Acep_Contact.Role];
            return x;
        }
    }

}





// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/crm-application.model.ts